import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {Location} from '@angular/common';


@Component({
  selector: 'app-inv-tabs',
  templateUrl: './inv-tabs.component.html',
  styleUrls: ['./inv-tabs.component.css']
})
export class InvTabsComponent implements OnInit {

  /**
   * Identificador de Invoicing Service
   */
  identifier: string;

  swLinkActivesMap = new Map<string, boolean>()
    .set('platforms',false)
    .set('clients',false)
    .set('receivers',false);

  constructor(private router: Router,
              private location: Location,
              private route: ActivatedRoute,) {
    this.initLinkActive();
  }

  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        this.identifier = params['identifier'];
      });
  }

  initLinkActive() {
    this.setLinkActive('platforms');
    if (this.location.path()) {
      if (this.location.path().endsWith('plataformas')) {
        this.setLinkActive('platforms');
      } else if (this.location.path().endsWith('clientes')) {
        this.setLinkActive('clients');
      } else if (this.location.path().endsWith('receptores')) {
        this.setLinkActive('receivers');
      }
    }
  }

  onPlatformsTabClicked() {
    this.setLinkActive('platforms');
    this.router.navigate(['/empresas/'+this.identifier+'/plataformas']).then();
  }

  onClientsTabClicked() {
    this.setLinkActive('clients');
    this.router.navigate(['/empresas/'+this.identifier+'/clientes']).then();
  }

  onReceiversTabClicked() {
    this.setLinkActive('receivers');
    this.router.navigate(['/empresas/'+this.identifier+'/receptores']).then();
  }

  isLinkActive(keyLink: string) : boolean {
    return this.swLinkActivesMap.get(keyLink);
  }

  setLinkActive(keyLink: string) {
    this.swLinkActivesMap
      .set('platforms',false)
      .set('clients',false)
      .set('receivers',false);
    this.swLinkActivesMap.set(keyLink, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-tabs/inv-tabs.component.ts